
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 38h12v-7.264a6 6 0 00-.927-3.204l-10.19-16.134A3 3 0 0028.346 10H7.5A1.5 1.5 0 006 11.5v1A3.5 3.5 0 009.5 16h14.374c.803 0 1.347.817 1.038 1.558l-1.338 3.211A2 2 0 0121.728 22H14a4 4 0 00-4 4v.5a1.5 1.5 0 001.5 1.5h9.213a3 3 0 011.606.466l6.984 4.426A1.5 1.5 0 0130 34.159V38z","fill":"#535353","fill-rule":"nonzero"}})])
          )
        }
      }
    